import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import sendgridApi from 'src/api/communityApi';
import { TemplateInterface } from "../../store/sendgrid/templatesSlice";

const PREFIX = 'sendgrid';

const processStrategy = (value: any) => {
  return { ...value };
}

export const templatesEntity = new schema.Entity(
  'templates',
  {},
  {
    processStrategy
  }
);

export const templateEntity = new schema.Entity(
  'template',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      template: TemplateInterface;
    }
  >(response.data.template, templateEntity);
  return normalized.entities;
}

const normalizeCollection = (response: AxiosResponse) => {
  const normalized  = normalize<
    any,
    {
      templates: { [key: string]: TemplateInterface },
    }
    >(response.data.templates, [templatesEntity]);

  return {
    templates: normalized.entities?.templates || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchTemplates = createAsyncThunk(
  `${PREFIX}_templates/fetchTemplates`,
  async (params: object = {}) => {
    const response = await sendgridApi.get(`/onesky/sendgrid/templates`, { params })
    return normalizeCollection(response);
  }
);

export const fetchTemplate = createAsyncThunk(
  `${PREFIX}_templates/fetchTemplate`,
  async (id: number | string) => {
    const response = await sendgridApi.get(`/onesky/sendgrid/templates/${id}`);
    return normalizeInstance(response);
  }
);
